import { groupPath } from 'helper/recordPaths';
import { Navigate, useLocation, useParams } from 'react-router-dom';

// /company/group/:id → /group/:id: the former address of a group's page, kept
// for the links already shared; the query (?onglet=…) follows.
const LegacyGroupRedirect = () => {
  const { id } = useParams();
  const { search } = useLocation();
  return <Navigate to={`${groupPath(id)}${search}`} replace />;
};

export default LegacyGroupRedirect;
